import { isObject, size } from "lodash";

/**
 * "tenantInfo" in Vue is always a list, so this conversion tries to take
 * care of that.
 *
 * @param tenantData
 */
const tenantDataFromTenantInfo = (tenantData) => {
  if (!tenantData) {
    return [];
  }

  if (Array.isArray(tenantData)) {
    return tenantData;
  }

  return [tenantData];
};

const enhanceWithVueAttributes = (customerData) => {
  if (
    customerData == null ||
    !(isObject(customerData) && size(customerData) > 0)
  ) {
    throw new Error("Customer data must be a non-empty object");
  }

  const result = { ...customerData };
  result.cid = customerData?.customerId;
  result.pbxList = Object.entries(result?.pbxMap ?? {}).map((entry) => {
    const [pbxId, pbxName] = entry;
    return {
      name: pbxName,
      id: pbxId,
    };
  });

  // Set 'pbx' in the Vue data to the preselected PBX in React.
  result.pbx = null;
  const preselectedPbxId = customerData?.preselectedPbxId;
  if (preselectedPbxId) {
    result.pbx = result.pbxList.find((pbx) => pbx.id === preselectedPbxId);
  }

  result.adminList = result?.primaryAdministrator?.loginId
    ? [result?.primaryAdministrator?.loginId]
    : [];
  result.tenantInfo = tenantDataFromTenantInfo(result?.tenantData);

  // These properties look unused by almost all tools, so we will not concern
  // ourselves with supporting them for now.
  result.auxiliaryLoginList = null;

  return result;
};

export default enhanceWithVueAttributes;
